import {ActionFactory} from '@/engine/actions';
import {BatchUpdate} from '@/types/document/store';
import {cleanupAllocationForm} from '../utils';

export const cancelAllocationAction: ActionFactory<'cancelAllocation'> = (_, store, valueResolver) => {
  return () => {
    const updates: BatchUpdate[] = [];

    cleanupAllocationForm(updates, valueResolver);

    store.getState().batchUpdate(updates);

    return true;
  };
};
